module.exports = __webpack_public_path__ + "bradavice_7_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/bradavice_7_before_tn.jpg
// module id = 1410
// module chunks = 0